import React from "react";
import Button from "./Button";

const ProductForm = ({
  form,
  onChange,
  onFile,
  onSubmit,
  onCancel,
  loading,
}) => {
  return (
    <div className="bg-white shadow-md rounded-lg p-4 md:p-6 mb-6 border">

      <h2 className="text-lg md:text-xl font-semibold mb-4">
        New Product
      </h2>

      <div className="grid grid-cols-1 gap-3">

        {/* NAME */}
        <input
          name="name"
          placeholder="Name"
          value={form.name}
          onChange={onChange}
          className="border p-2 rounded-md w-full"
        />

        {/* LISTING TYPE */}
        <div className="border p-3 rounded-md bg-gray-50">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Listing Type
          </label>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-6">

            {/* FOR SALE */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="listing_type"
                value="sale"
                checked={form.listing_type === "sale"}
                onChange={onChange}
              />

              <span>For Sale</span>
            </label>

            {/* WANTED */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="listing_type"
                value="wanted"
                checked={form.listing_type === "wanted"}
                onChange={onChange}
              />

              <span>Wanted</span>
            </label>

          </div>
        </div>

        {/* PRICE */}
        <input
          name="price"
          type="number"
          placeholder="Price"
          value={form.price}
          onChange={onChange}
          className="border p-2 rounded-md w-full"
        />

        {/* LOCATION */}
        <input
          name="location"
          placeholder="Location"
          value={form.location}
          onChange={onChange}
          className="border p-2 rounded-md w-full"
        />

        {/* DESCRIPTION */}
        <textarea
          name="description"
          placeholder="Description"
          value={form.description}
          onChange={onChange}
          rows="4"
          className="border p-2 rounded-md w-full"
        />

        {/* PHONE */}
        <input
          name="contact_phone"
          type="tel"
          placeholder="Phone Number"
          value={form.contact_phone}
          onChange={onChange}
          className="border p-2 rounded-md w-full"
        />

        {/* WHATSAPP */}
        <input
          name="contact_whatsapp"
          type="tel"
          placeholder="WhatsApp Number"
          value={form.contact_whatsapp}
          onChange={onChange}
          className="border p-2 rounded-md w-full"
        />

        {/* IMAGES */}
        <div className="border-t pt-4 mt-2">
          <h3 className="font-semibold text-sm md:text-base mb-3">
            Product Images
          </h3>

          <div className="grid grid-cols-1 gap-3">

            {/* IMAGE 1 - REQUIRED */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Image 1 (Main Image){" "}
                <span className="text-red-600">*</span>
              </label>

              <input
                type="file"
                accept="image/*"
                onChange={(e) => onFile(e, "image1")}
                required
                className="border p-2 rounded-md w-full"
              />
            </div>

            {/* IMAGE 2 - OPTIONAL */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Image 2{" "}
                <span className="text-gray-500">(Optional)</span>
              </label>

              <input
                type="file"
                accept="image/*"
                onChange={(e) => onFile(e, "image2")}
                className="border p-2 rounded-md w-full"
              />
            </div>

            {/* IMAGE 3 - OPTIONAL */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Image 3{" "}
                <span className="text-gray-500">(Optional)</span>
              </label>

              <input
                type="file"
                accept="image/*"
                onChange={(e) => onFile(e, "image3")}
                className="border p-2 rounded-md w-full"
              />
            </div>

            {/* IMAGE 4 - OPTIONAL */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Image 4{" "}
                <span className="text-gray-500">(Optional)</span>
              </label>

              <input
                type="file"
                accept="image/*"
                onChange={(e) => onFile(e, "image4")}
                className="border p-2 rounded-md w-full"
              />
            </div>

            {/* IMAGE 5 - OPTIONAL */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Image 5{" "}
                <span className="text-gray-500">(Optional)</span>
              </label>

              <input
                type="file"
                accept="image/*"
                onChange={(e) => onFile(e, "image5")}
                className="border p-2 rounded-md w-full"
              />
            </div>

          </div>
        </div>

      </div>

      {/* BUTTONS */}
      <div className="flex flex-col md:flex-row gap-3 mt-4">

        <Button
          onClick={onSubmit}
          disabled={loading}
          className="w-full md:w-auto"
        >
          {loading ? "Uploading..." : "Save"}
        </Button>

        <Button
          variant="outline"
          onClick={onCancel}
          className="w-full md:w-auto"
        >
          Cancel
        </Button>

      </div>

    </div>
  );
};

export default ProductForm;
